import styles from "./ContactStatusBadge.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CONTACT_TYPE } from "shared/enums";

const options = {
  [CONTACT_TYPE.Prospect]: {
    label: "P",
    className: styles.prospect,
  },
  [CONTACT_TYPE.Customer]: {
    label: "C",
    className: styles.customer,
  },
  [CONTACT_TYPE.Archived]: {
    label: "X",
    className: styles.archived,
  },
  [undefined]: {
    label: "IBO",
    className: styles.ibo,
  },
};

const stepStyles = {
  Prospect: {
    label: "P",
    className: styles.stepProspect,
  },
  "Meet & Greet": {
    label: "MG",
    className: styles.stepMeetAndGreet,
  },
  "Napkin Plan": {
    label: "NP",
    className: styles.stepNapkinPlan,
  },
  "One-on-One": {
    label: "Oo",
    className: styles.stepOneOnOne,
  },
  "Board Plan": {
    label: "BP",
    className: styles.stepBoardPlan,
  },
  "Follow Up": {
    label: "F",
    className: styles.stepFollowUp,
  },
  "Open Meeting": {
    label: "OM",
    className: styles.stepOpenMeeting,
  },
  "Budget Session": {
    label: "B",
    className: styles.stepBudgetSession,
  },
  "Major Function": {
    label: "MF",
    className: styles.stepMajorFunction,
  },
};

/**
 * Circular badge displayed to the right of a contact's name in the contact list.
 * Specifies the contact's type.
 */
export function ContactStatusBadge({ type, progression }) {
  if (options[type] == null) {
    throw new Error(`Unknown status type: ${type}`);
  }

  let { label, className } = options[type];

  if (type == CONTACT_TYPE.Prospect) {
    const step = stepStyles[progression];

    if (step != null) {
      label = step.label;
      className = step.className;
    }
  }

  return <div className={classNames(styles.badge, className)}>{label}</div>;
}

ContactStatusBadge.propTypes = {
  /**
   * The status this badge will display.
   */
  type: PropTypes.oneOf([
    CONTACT_TYPE.Prospect,
    CONTACT_TYPE.Customer,
    CONTACT_TYPE.Archived,
  ]),
  progression: PropTypes.string,
};
